{
  "pages": [
    {
      "name": "Heat Exchanger ",
      "elements": [
        {
          "type": "panel",
          "name": "panel7",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "MAGNA3"
                },
                {
                  "value": "TPE",
                  "text": "TPE"
                },
                {
                  "value": "TPE2",
                  "text": "TPE2"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "Alpha",
                  "text": "ALPHA"
                },
                {
                  "value": "UPS",
                  "text": "UPS"
                },
                {
                  "value": "Pump",
                  "text": "Other"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "visibleIf": "{P_type} = \"Magna3\" or {P_type} = \"TPE\" or {P_type} = \"TPE2\" or {P_type} = \"TPE3\"",
              "title": "Enable pump connectivity?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "P_address",
              "visibleIf": "{P_connected} = true",
              "isRequired": false,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Pump"
        }
      ]
    }
  ]
}